import React, { Component } from 'react';
import Dico from '../../helpers/Dico';

class CalculatorInfoBenefit extends Component {

    render() {
        return (
            this.props.benefit && Object.keys(this.props.benefit).length > 0 && <div className="card row">
                <div className='card-header'>
                    <button type="button" className="btn-close float-end" aria-label="Close" onClick={this.props.handleCloseBenefit}></button>
                    <h5>{this.props.benefit.label}</h5>
                </div>
                <div className='card-body'>
                    {this.props.benefit.informations && this.props.benefit.informations.map((info, index) => {
                        return (<div key={index}>{Dico.getRichText(info.text)}
                            {info.specifications && <ul>
                                {info.specifications.map((spec, index2) => {
                                    return (<li key={index2}>{Dico.getRichText(spec)}</li>);
                                })}
                            </ul>}
                        </div>);
                    })}
                    {this.props.benefit.conditions && this.props.benefit.conditions.map((cond, index) => {
                        return (<p className='fst-italic' key={index}>{Dico.getRichText(cond)}</p>);
                    })}
                </div></div >
        );
    }
}
export default (CalculatorInfoBenefit)
